import React, { useContext } from 'react';
import { ElementViewBuilderContext } from 'core/context';
import { ElementViewBuilderConfig } from 'core/ElementViewBuilder';
import TableTextAction from '../TableTextAction';

const PaycutSummaryAction = ({ paycutId, children = paycutId }) => {
	const { setElementView } = useContext(ElementViewBuilderContext);

	const handleOpenSummary = event => {
		event.stopPropagation();
		const elementViewKeys =
			ElementViewBuilderConfig.getAuthorizedElementViewKeys();

		setElementView({
			elementViewKey:
				elementViewKeys.BILLING_PAYMENT_PAYCUT_DETAILS_REQUEST_ELEMENT,
			elementId: paycutId,
			paycutId,
			isInvoice: false,
			drawerConfig: {
				maxWidth: '50vw',
				fullWidthBelow: '768px',
				noOverflow: true,
			},
			initialView: {
				tabKey: 'summaryKey',
				summaryOnly: true,
				paycutSummary: true,
				readOnly: true,
				titleTab: `Resumen del pago #${paycutId}`,
			},
		});
	};

	return (
		<TableTextAction
			type='button'
			onClick={handleOpenSummary}
			aria-label={`Abrir resumen del pago ${paycutId}`}
		>
			{children}
		</TableTextAction>
	);
};

export default PaycutSummaryAction;
